/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FullenrichCreditsUsage
 */
export interface FullenrichCreditsUsage {
    /**
     * 
     * @type {number}
     * @memberof FullenrichCreditsUsage
     */
    used: number;
    /**
     * 
     * @type {number}
     * @memberof FullenrichCreditsUsage
     */
    limit: number;
}

/**
 * Check if a given object implements the FullenrichCreditsUsage interface.
 */
export function instanceOfFullenrichCreditsUsage(value: object): value is FullenrichCreditsUsage {
    if (!('used' in value) || value['used'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function FullenrichCreditsUsageFromJSON(json: any): FullenrichCreditsUsage {
    return FullenrichCreditsUsageFromJSONTyped(json, false);
}

export function FullenrichCreditsUsageFromJSONTyped(json: any, ignoreDiscriminator: boolean): FullenrichCreditsUsage {
    if (json == null) {
        return json;
    }
    return {
        
        'used': json['used'],
        'limit': json['limit'],
    };
}

  export function FullenrichCreditsUsageToJSON(json: any): FullenrichCreditsUsage {
      return FullenrichCreditsUsageToJSONTyped(json, false);
  }

  export function FullenrichCreditsUsageToJSONTyped(value?: FullenrichCreditsUsage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'used': value['used'],
        'limit': value['limit'],
    };
}

